import { template as template_f7e37d81c59e48a1940a04735e7ef38a } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { isPresent } from '@ember/utils';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import Portal from 'ember-stargate/components/portal';
import SearchTag from 'eflex/components/filters/search-tag';
import FilterWrapper from 'eflex/components/filters/filter-wrapper';
import { filterByIds, callWithMapped } from 'eflex/helpers';
export default class BiPanelModels extends Component {
    @service
    modelRepo;
    @service
    intl;
    @service
    store;
    @tracked
    isDisplayed = false;
    constructor(){
        super(...arguments);
        this.isDisplayed = this.args.modelIds?.length > 0;
        this.args.initParam('modelIds', this.args.modelIds);
    }
    @action
    onChange(models) {
        this.args.updateParam('modelIds', models);
    }
    get models() {
        return this.modelRepo.models;
    }
    get selectedModels() {
        return this.args.getParam('modelIds');
    }
    get selectedModelsBadgeText() {
        return this.args.createSearchBadgeText('modelIds', 'model', 'criteria.selectedModels', 'code', 'model');
    }
    onDisplayedChanged = ()=>{
        this.isDisplayed = !this.isDisplayed;
    };
    static{
        template_f7e37d81c59e48a1940a04735e7ef38a(`
    <Portal @target="filter-fields">
      <FilterWrapper
        class="eflex-models-criteria"
        @class="align-items-end"
        @form={{@form}}
        @label="models"
        @isDisplayed={{this.isDisplayed}}
        @onChecked={{this.onDisplayedChanged}}
        @hasValue={{isPresent this.selectedModels}}
        ...attributes
      >
        <div class="input-group">
          <div class="col">
            <div class="row">
              <div class="col">
                <@form.element
                  class="model-select"
                  @controlType="power-select-multiple"
                  @value={{filterByIds this.models this.selectedModels}}
                  @options={{this.models}}
                  @optionLabelPath="code"
                  @onChange={{callWithMapped this.onChange "id"}}
                as |el|>
                  <el.control
                    class="sm"
                    @searchEnabled={{true}}
                    @searchField="code"
                    @placeholder={{t "allModels"}}
                  />
                </@form.element>
              </div>
            </div>
          </div>
        </div>
      </FilterWrapper>
    </Portal>

    <Portal @target="search-badge-tags">
      <SearchTag
        @isDisplayed={{@modelIds}}
        @text={{this.selectedModelsBadgeText}}
      />
    </Portal>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
